<template>
  <!-- <div>
    <h2>{{ status }}</h2>
    <p v-if="subscriptionId">Subscription ID: {{ subscriptionId }}</p>
  </div> -->
  <section class="container-fluid login_page_section login-img">
    <div class="row align-items-center">
      <div class="col-md-6 login_left_section">
        <div class="text-center">
          <img src="../../public/assets/Images/Signup2.png" alt="" />
        </div>
      </div>
      <div class="col-md-6 login_right_section_signup">
        <div class="logo_section mx-3 mt-n1">
          <img src="../assets/Images/logo.png" alt="" width=""/>
        </div>
        <div style="clear: both"></div>
        <div class="row justify-content-center responsive"
          style="padding-right: var(--bs-gutter-x, 0.75rem); padding-left: var(--bs-gutter-x, 0.75rem);">
          <div class="col-xl-8 col-lg-10 col-md-11">
            <div class="login_page_heading">
              <h3 class="font-weight-800">Complete your PMaps Account Now!
              </h3>
              <p>Innovative Assessments for Efficient Recruitment</p>
            </div>
            <form action="">
              <div class="row my-4 mb-3">
                <div class="col-12 col-xl-6 col-sm-12 space">
                  <label class="input-hero">
                    <input class="input_area" required v-model="firstName" />
                    <span class="input-name" :class="{ 'input-focusedName': isFocused }"> First Name </span>
                  </label>
                </div>
                <div class="col-12 col-xl-6 col-sm-12 space">
                  <label class="input-hero">
                    <input class="input_area" required v-model="lastName" />
                    <span class="input-name" :class="{ 'input-focusedName': isFocused }"> Last Name </span>
                  </label>
                </div>
              </div>
              <div class="form-group mt-3">
                <div class="form-group mb-3">
                  <label class="input-hero">
                    <input class="input_area" type="text" required v-model="companyName" />
                    <span class="input-name">Company Name</span>
                  </label>
                </div>
              </div>
              <div class="form-group mt-4">
                <div class="form-group mb-3">
                  <label class="input-hero">
                    <input class="input_area" type="email" required v-model="Email" disabled />
                    <span class="input-name">Work Email</span>
                  </label>
                </div>
              </div>
              <!-- <div class="form-group mt-4">
                <div class="form-group mb-3">
                  <label class="input-hero">
                    <input class="input_area" type="tel" required v-model="Phone" />
                    <span class="input-name">Phone Number</span>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <div class="form-group mb-3">
                  <label class="input-hero">
                    <select class="form-select input_area select_ca" v-model="countryName" required>
                      <option disabled selected>Select Preferred Country</option>
                      <option v-for="item in GetLocationData.object.data" :key="item" :value="item.iso2">
                        {{ item.name }}
                      </option>
                    </select>
                    <span class="input-name">Country</span>
                  </label>
                </div>
              </div> -->
              <div class="form-group mt-4">
                <div class="form-group mb-3 position-relative">
                  <span class="input-name" :class="{ 'input-focused': isFocused }">Phone Number</span>
                  <vue-tel-input v-model="phoneNumber" :defaultCountry="defaultCountry" :enabledFlags="true"
                    :enabledCountryCode="true" :inputClasses="'form-control'" :wrapperClasses="'phone-input'"
                    :validCharactersOnly="true" :disabledFetchingCountry="true" :disabled="false" style="width: 100%"
                    :dropdownOptions="dropdownOptions" @validate="onValidate" @country-changed="onCountryChange"
                    @input="onInput" @blur="handleBlur" @focus="handleFocus" mode="international">
                  </vue-tel-input>


                  <!-- Validation message -->
                  <div v-if="!isValid && phoneNumber && phoneNumber.length > 4"
                    class="invalid-feedback d-block mt-1 small">
                    Phone number is not valid for {{ countryName }}
                  </div>
                </div>
              </div>
                           
              <div style="font-size: 15px; display: flex; align-items: center; margin-top: 5%;">
                <input type="checkbox" name="" id="" style="margin-right: 2%; " v-model="privacy">
                <span style="color: rgb(92, 92, 92);">By signing up you agree to PMaps's Terms and <a
                    href="https://pmapstest.com/privacy-policy/" target="_blank">Privacy Policy </a></span>
              </div>

              <div class="mt-4 login_button_area mb-6">
                <div class="row">
                  <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                  <router-link :to="{ name: 'Login' }" class="btn btn-primary2 me-3 mb-3" type="submit" style="width: 100%;">
                  Back to Login
                </router-link>
                 </div>  -->
                  <div class="col-12 ">
                    <!-- Separate function for disabled  -->
                    <button class="btn btn-primary" @click="createAccount" type="button"
                      style="width: 100%; font-size: 17px !important;" :disabled="ValidateData()">
                      Subscribe
                    </button>
                  </div>
                </div>
                <div class="float-end mt-3 mb-5">
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>


</template>

<script>
import { mapActions } from "vuex";
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'

export default {
  components: {
    VueTelInput
  },
  data() {
    return {
      status: "",
      subscriptionId: null,
      // Signup Component details
      emailError: "",
      GetLocationData: {
        object: {
          data: [],
        },
      },
      companyName: "",
      firstName: "",
      lastName: "",
      countryName: "",
      countryISO2: '',
      Email: "",
      lat: "",
      lng: "",
      error: "",
      country: "",
      privacy: false,
      phoneNumber: '',
      isValid: true,
      selectedCountry: '',
      defaultCountry: 'IN',
      currentDialCode: '',
      previousDialCode: '',
      hasBlurred: false,
      isFocused: false,
      dropdownOptions: {
        showDialCode: true,
        showFlags: true,
        showCode: true,
        tabindex: 0,
        showDialCodeInList: true,
      },
      plancode: "",
      PhoneError: "",
    }
  },
  async created() {
    this.GetLocationData = await this.getlocation();  
  },
  async mounted() {
    const token = this.$route.query.token

    if (!token) {
      return this.ShowWarningMessage("Missing token in URL");
    }
    var response = await this.ValidateMicrosoftResolveToken(token);
    if(response == undefined || !response.status){
      return this.ShowWarningMessage("Failed to resolve subscription.");      
    }

    this.subscriptionId = response.object.data.subscriptionId
    this.status = 'Subscription resolved successfully!',
    this.Email = response.object.data.emailId,
    this.plancode = response.object.data.plan 

    await this.fetchLocation();
  },
  methods:{
    ...mapActions(["ValidateMicrosoftResolveToken","getlocation","ShowWarningMessage", "billingSignupV2",]),
        
    ValidateData() {
      return this.privacy == false || this.Email == '' || this.phoneNumber == '' || this.companyName == '' || this.firstName == '' || this.lastName == '' ;
    },

    validatePhoneNumber() {
      if (!this.isValid) {
        return this.ShowWarningMessage("Enter valid phone number");
      } else {
        return true;
      }
    },

    handleFocus() {
      this.isFocused = true
    },

    onValidate({ valid, country }) {  
        this.isValid = valid
        if (country) {
          this.selectedCountry = country.iso2
          this.countryName = country.name;
        }       
        this.$emit('phone-input-change', {
          phoneNumber: this.phoneNumber,
          countryName: this.selectedCountry,
          isValid: this.isValid
        })
    },

    onCountryChange(country) {
      if (country) {
        this.currentDialCode = country.dialCode.replace('+', '');
        this.selectedCountry = country.iso2;
        this.countryName = country.name;
        this.phoneNumber = `+${country.dialCode}`;
        this.$emit('phone-input-change', {
          phoneNumber: this.phoneNumber,
          countryName: this.selectedCountry,
          isValid: true
        });
      }
    },

    onInput(event) {
      const formattedNumber = String(event.target.value);
      const dialCodeRegex = new RegExp(`^\\+${this.currentDialCode}`);
      if (!formattedNumber.match(dialCodeRegex)) {
        this.phoneNumber = `+${this.currentDialCode}`;
      } else {
        const baseNumber = `+${this.currentDialCode}`;
        const extraDigits = formattedNumber.substring(baseNumber.length).replace(/[^\d]/g, '');
        if (extraDigits) {
          this.phoneNumber = `${baseNumber}${extraDigits}`;
        } else {
          this.phoneNumber = baseNumber;
        }
      }
    },

    handleBlur() {
      this.isFocused = false
      this.hasBlurred = true
    },

    async createAccount() {
      if (this.validateEmail() == true && this.validatePhoneNumber() == true) {
        var newUserObj = await this.billingSignupV2({
          name: this.companyName,
          domain: this.domain,
          isPartner: true,
          countryCode: this.selectedCountry,
          // logo: "string",
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.Email,
          plan: this.plancode,
          mobileNo: this.phoneNumber,
          referrer: "Microsoft",
          subscriptionId: this.subscriptionId 
        });
        this.$router.push(`/otp-code-new/${newUserObj.object.data.token}/${btoa(newUserObj.object.data.userId)}/${btoa(newUserObj.object.data.email)}`);
      }
    },

    validateEmail() {
      const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,10})+$/;
      const disallowedDomains = ["outlook", "hotmail", "gmail", "yahoo", "aol", "icloud", "rediff", "email", "rediffmail"];
      const email = this.Email.trim().toLowerCase();
      if (!emailRegex.test(email)) {
        return this.ShowWarningMessage("Please enter a valid email addresses");
      }
      else {
        const emailSplit = email.split("@")[1];
        this.domain = emailSplit.split(".")[0];
        if (disallowedDomains.includes(this.domain)) {
          return this.ShowWarningMessage("Emails from " + this.domain + " are not allowed");
        } else {
          return true;
        }
      }
    },

    fetchLocation() {
      fetch("https://ipapi.co/json/")
        .then((response) => response.json())
        .then((data) => {

          const country = this.GetLocationData.object.data.find(item => item.name === data.country_name);
          if (country) {
            this.defaultCountry = country.iso2;
            this.selectedCountry = country.iso2;
            this.countryName = country.name;

            this.currentDialCode = country.phonecode.replace('+', '');

            this.$nextTick(() => {
              this.phoneNumber = `+${this.currentDialCode}`;
            });
          }
        })
    },
    
  }

}
</script>
